//
// Copyright (c) 2020 Astute Global, Inc.
//
// Model to keep track of the users that are currently using a particular topic.
//

define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  "use strict";

  var TopicUsageModel = {};

  TopicUsageModel.topicUsage = Backbone.Model.extend({
    idAttribute: "userId",
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      if (!this.intentId && this.collection) {
        this.intentId = this.collection.intentId;
      }
      if (!kbId || !this.intentId) {
        return "";
      }
      return Properties.rootURL + "/" + kbId + "/intents/" + this.intentId + "/usage";
    },
  });

  TopicUsageModel.topicUsages = Backbone.Collection.extend({
    model: TopicUsageModel.topicUsage,
    url: function () {
      var kbId = Messenger.reqres.request("active:kb");
      if (!kbId || !this.intentId) {
        return "";
      }
      return Properties.rootURL + "/" + kbId + "/intents/" + this.intentId + "/usage";
    },
  });

  return TopicUsageModel;
});
